"use client";

import { useEffect, useState } from "react";

/**
 * true quando a largura da viewport é menor que `breakpoint`.
 * SSR-safe: começa `false` (desktop) e ajusta na montagem via matchMedia.
 */
export function useIsMobile(breakpoint = 768): boolean {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
        const update = () => setIsMobile(mq.matches);

        update();
        mq.addEventListener("change", update);
        return () => mq.removeEventListener("change", update);
    }, [breakpoint]);

    return isMobile;
}
